var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header"},[_c('header-head',{attrs:{"login":_vm.login},on:{"updateLogin":_vm.updateLogin}}),_c('header-main'),_c('header-nav',{on:{"refreshView":_vm.refreshView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }